export enum ElevioOpenKind {
    Panel = 'Panel',
    Article = 'Article',
    Module = 'Module'
}

const ElevioGroups = {
    AllowProfileEditing: 'AllowProfileEditing',
    ShowMakeupCredits: 'ShowMakeupCredits',
    ShowTeacherEmailAndPhone: 'ShowTeacherEmailAndPhone',
    ShowTeacherAddress: 'ShowTeacherAddress',
    ShowStudentPortalContactList: 'ShowStudentPortalContactList',
    AllowStudentTimezone: 'AllowStudentTimezone',
    Parent: 'Parent',
    Student: 'Student',
    Subscribed: 'Subscribed',
    NotSubscribed: 'NotSubscribed',
    CanEditInvoices: 'CanEditInvoices',
    CanEditStudents: 'CanEditStudents',
    AdminMulti: 'admin_multi',
    AdminSingle: 'admin_single',
    TeacherMulti: 'teacher_multi',
    TeacherSingle: 'teacher_single',
    EarlyAdopter: 'EarlyAdopter',
    AllowOnlineCancellation: 'AllowOnlineCancellation',
    AllowOnlineSignUp: 'AllowOnlineSignUp'
};
const ElevioUserTraits = {
    MultiTeacher: 'Multi Teacher',
    SingleTeacher: 'Single Teacher',
};

type ElevioGroups = typeof ElevioGroups;
type ElevioUserTraits = typeof ElevioUserTraits;
type ElevioPortalConfiguration = { Groups: Readonly<ElevioGroups>, UserTraits: Readonly<ElevioUserTraits> };
// export type ElevioArticleIDs = typeof ElevioArticleIDs;
export type ElevioArticleIDs = {
    WebsiteBuilder: {
        Upload: number,
        Hostname: number,
        ScriptCode: number,
        NoTeachersVisible: number
    },
    EmailSettings: {
        SPF: number,
        DKIM: number
    },
    Reminders: {
        Email: number,
        SMS: number
    },
    ProfilePictureUpload: {
        ForTeacher: number,
        ForStudent: number
    },
    BusinessLogoUpload: number,
    AddPolicyAgreement: {
        ToSignupForm: number,
        ToContactForm: number
    },
    GoogleReviews: number,
}
type ElevioConfiguration = { PortalConfiguration: Readonly<ElevioPortalConfiguration>, Articles?: ElevioArticleIDs };

export const Elevio: ElevioConfiguration = {
    PortalConfiguration: {
        Groups: ElevioGroups,
        UserTraits: ElevioUserTraits
    }
};

// Provide a default Articles object so code and tests that don't
// configure Elevio still have the expected structure available.
Elevio.Articles = {
    WebsiteBuilder: {
        Upload: 0,
        Hostname: 0,
        ScriptCode: 0,
        NoTeachersVisible: 0
    },
    EmailSettings: {
        SPF: 0,
        DKIM: 0
    },
    Reminders: {
        Email: 0,
        SMS: 0
    },
    ProfilePictureUpload: {
        ForTeacher: 0,
        ForStudent: 0
    },
    BusinessLogoUpload: 0,
    AddPolicyAgreement: {
        ToSignupForm: 0,
        ToContactForm: 0
    },
    GoogleReviews: 0
};
